import { IPaginated } from 'types';
import { ICompany } from '../Cultures/slice/types';
import { ITaskCategory } from '../Task/slice/types';
import { ISimpleUser } from '../User/slice/types';

export type GarageTabKeyType = 'transport' | 'implement' | 'employee';

export interface IAccountingMethodPrice {
  id: number;
  name: string;
  category: string;
  costPrice: number;
  sellPrice: number;
}
export interface IGarageUnitType {
  id: number;
  name: string;
  category: string;
}
export interface ITransport {
  id: number;
  type: IGarageUnitType;
  licensePlate: string;
  company: ICompany;
  gpsVehicle: IGpsTransport | null;
  defaultTaskCategory: ITaskCategory;
  taskCategories: ITaskCategory[];
  width: number | null;
  model: string;
  year: number | null;
  motoHours: number | null;
  accountingMethods: IAccountingMethodPrice[];

  archived: boolean;
  createdBy: ISimpleUser;
  updatedBy: ISimpleUser;
  createdAt: string;
  updatedAt: string;
}

export interface ITransportResponse extends IPaginated<ITransport> {}

export interface IGpsTransport {
  id: number;
  companyId: number;
  garageVehicleId: number | null;
  gpsId: number;
  licensePlate: string;
  createdAt: string;
  updatedAt: string;
  assigned: boolean;
  color: string;
}

export interface IGpsImplement {
  beaconId: string;
  createdAt: string;
  id: number;
  name: string;
  updatedAt: string;
  companyId: number;
  garageImplementId: number | null;
  assigned: boolean;
}

export interface IGpsEmployee {
  assigned: boolean;
  companyId: number;
  createdAt: string;
  garageEmployeeId: number;
  id: number;
  name: string;
  slimId: string;
  updatedAt: string;
}

export interface IAddTransportPayload {
  defaultTaskCategoryId?: number;
  width?: number;
  envId: number;
  companyId: number;
  typeId: number;
  gpsVehicleId?: number;
  model: string;
  licensePlate: string;
  year?: number;
  motoHours?: number;
  taskCategoryIds?: number[];

  accountingMethods: {
    costPrice: number | undefined;
    id: number;
    sellPrice: number | undefined;
  }[];
}

export interface IUpdateTransportPayload extends IAddTransportPayload {
  transportId: number;
}

export interface IAddImplementPayload {
  envId: number;
  companyId: number;
  typeId: number;
  gpsImplementId?: number;
  model: string;
  year?: number;
  width?: number;
  taskCategoryIds?: number[];
  defaultTaskCategoryId: number;

  accountingMethods: {
    costPrice: number | undefined;
    id: number;
    sellPrice: number | undefined;
  }[];
}

export interface IUpdateImplementPayload extends IAddImplementPayload {
  implementId: number;
}
export interface ITransportFilters {
  taskCategoryIds?: number[];
  typeId?: number;
  search?: string;
}

export interface IAccountingMethod {
  category: string;
  id: number;
  name: string;
}

export const ACCOUNTING_METHODS_MAP = {
  motoHours: 1,
  ha: 2,
  km: 3,
} as const;

export const IMPLEMENT_ACCOUNTING_METHODS_MAP = {
  motoHours: 4,
  ha: 5,
} as const;

export const EMPLOYEE_ACCOUNTING_METHODS_MAP = {
  ha: 6,
  hours: 7,
} as const;

export interface ITransportFormValues {
  typeId: number;
  model: string;
  companyId: number;
  licensePlate: string;
  gpsVehicleId?: number;
  year?: string;
  motoHours?: string;
  defaultTaskCategoryId?: number;
  taskCategoryIds?: number[];
  accountingMethods?: number[] | undefined;
  motoHourCostPrice?: string;
  motoHourSellPrice?: string;

  haCostPrice?: string;
  haSellPrice?: string;

  kmCostPrice?: string;
  kmSellPrice?: string;
}

// Implement
export interface IImplement {
  id: number;
  type: IGarageUnitType;
  company: ICompany;
  gpsImplement: IGpsImplement | null;
  defaultTaskCategory: ITaskCategory;
  taskCategories: ITaskCategory[];

  model: string;
  year: number;
  width: number;
  accountingMethods: IAccountingMethodPrice[];
  archived: boolean;
  createdBy: ISimpleUser;
  updatedBy: ISimpleUser;
  createdAt: string;
  updatedAt: string;
}

export interface IImplementResponse extends IPaginated<IImplement> {}

export interface IImplementFormValues {
  typeId: number;
  model: string;
  companyId: number;
  gpsImplementId?: number;
  year?: string;
  width?: string;
  taskCategoryIds?: number[];
  defaultTaskCategoryId: number;

  accountingMethods?: number[] | undefined;

  motoHourCostPrice?: string;
  motoHourSellPrice?: string;

  haCostPrice?: string;
  haSellPrice?: string;
}

// Employee
export interface IEmployee {
  id: number;
  company: ICompany;
  firstName: string;
  lastName: string;
  birthYear?: number;
  phoneNumber?: string;
  accountingMethods: IAccountingMethodPrice[];
  salary: null | number;
  archived: boolean;
  createdBy: ISimpleUser;
  updatedBy: ISimpleUser;
  createdAt: string;
  updatedAt: string;
  gpsEmployee: {
    assigned: boolean;
    companyId: number;
    createdAt: string;
    garageEmployeeId: number;
    id: number;
    name: string;
    slimId: string;
    updatedAt: string;
  } | null;
}

export interface IEmployeeResponse extends IPaginated<IEmployee> {}

export interface IEmployeeFormValues {
  firstName: string;
  phoneNumber?: string;
  companyId: number;
  gpsEmployeeId?: number;
  birthYear?: string;
  salary?: string;
  accountingMethods?: number[] | undefined;

  hourCostPrice?: string;
  hourSellPrice?: string;

  haCostPrice?: string;
  haSellPrice?: string;
}

export interface IAddEmployeePayload {
  envId: number;
  companyId: number;
  accountingMethods: {
    costPrice: number | undefined;
    id: number;
    sellPrice: number | undefined;
  }[];
  birthYear?: number;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  salary?: number;
  gpsEmployeeId?: number;
}

export interface IUpdateEmployeePayload extends IAddEmployeePayload {
  employeeId: number;
}

export interface IEmployeeFilters {
  birthYear?: string;
  search?: string;
}
